import { useCallback } from 'react';
import { withTiming } from 'react-native-reanimated';
import { useSafeAreaFrame } from 'react-native-safe-area-context';

import { useFloor } from './FloorContext';

export const useFloorNavigation = () => {
  const { width } = useSafeAreaFrame();
  const {
    translateFront,
    translateSide,
    translateRoofTop,
    translateFirstFloorFront,
    translateFirstFloorSide,
    translateSecondFloorFront,
    translateSecondFloorSide,
    translateThirdFloorFront,
    translateThirdFloorSide,
    translateRoofTopFront,
  } = useFloor();
  const handleFirstFloorClick = useCallback(() => {
    translateFirstFloorFront.value = withTiming(translateFirstFloorFront.value - width, {
      duration: 800,
    });
    translateFirstFloorSide.value = withTiming(translateFirstFloorFront.value + width, {
      duration: 800,
    });

    translateSecondFloorFront.value = withTiming(translateFront, { duration: 600 });
    translateSecondFloorSide.value = withTiming(translateSide, { duration: 600 });
    translateThirdFloorFront.value = withTiming(translateFront, { duration: 600 });
    translateThirdFloorSide.value = withTiming(translateSide, { duration: 600 });
    translateRoofTopFront.value = withTiming(translateRoofTop, { duration: 600 });
  }, [width]);

  const handleSecondFloorClick = useCallback(() => {
    translateSecondFloorFront.value = withTiming(translateSecondFloorFront.value - width, {
      duration: 800,
    });
    translateSecondFloorSide.value = withTiming(translateSecondFloorFront.value + width, {
      duration: 800,
    });

    translateFirstFloorFront.value = withTiming(translateFront, { duration: 600 });
    translateFirstFloorSide.value = withTiming(translateSide, { duration: 600 });
    translateThirdFloorFront.value = withTiming(translateFront, { duration: 600 });
    translateThirdFloorSide.value = withTiming(translateSide, { duration: 600 });
    translateRoofTopFront.value = withTiming(translateRoofTop, { duration: 600 });
  }, [width]);

  const handleThirdFloorClick = useCallback(() => {
    translateThirdFloorFront.value = withTiming(translateThirdFloorFront.value - width, {
      duration: 800,
    });
    translateThirdFloorSide.value = withTiming(translateThirdFloorFront.value + width, {
      duration: 800,
    });

    translateFirstFloorFront.value = withTiming(translateFront, { duration: 600 });
    translateFirstFloorSide.value = withTiming(translateSide, { duration: 600 });
    translateSecondFloorFront.value = withTiming(translateFront, { duration: 600 });
    translateSecondFloorSide.value = withTiming(translateSide, { duration: 600 });
    translateRoofTopFront.value = withTiming(translateRoofTop, { duration: 600 });
  }, [width]);

  const handleRoofTopClick = useCallback(() => {
    translateRoofTopFront.value = withTiming(translateRoofTopFront.value - width, {
      duration: 800,
    });

    translateFirstFloorFront.value = withTiming(translateFront, { duration: 600 });
    translateFirstFloorSide.value = withTiming(translateSide, { duration: 600 });
    translateSecondFloorFront.value = withTiming(translateFront, { duration: 600 });
    translateSecondFloorSide.value = withTiming(translateSide, { duration: 600 });
    translateThirdFloorFront.value = withTiming(translateFront, { duration: 600 });
    translateThirdFloorSide.value = withTiming(translateSide, { duration: 600 });
  }, [width]);

  return {
    handleFirstFloorClick,
    handleSecondFloorClick,
    handleThirdFloorClick,
    handleRoofTopClick,
  };
};
